var map = {
	"./_collections": 3193,
	"./_collections.js": 3193,
	"./_path": 8903,
	"./_path.js": 8903,
	"./_transforms": 4408,
	"./_transforms.js": 4408,
	"./addAttributesToSVGElement": 4530,
	"./addAttributesToSVGElement.js": 4530,
	"./addClassesToSVGElement": 5810,
	"./addClassesToSVGElement.js": 5810,
	"./cleanupAttrs": 2423,
	"./cleanupAttrs.js": 2423,
	"./cleanupEnableBackground": 1153,
	"./cleanupEnableBackground.js": 1153,
	"./cleanupIDs": 1625,
	"./cleanupIDs.js": 1625,
	"./cleanupListOfValues": 9699,
	"./cleanupListOfValues.js": 9699,
	"./cleanupNumericValues": 2778,
	"./cleanupNumericValues.js": 2778,
	"./collapseGroups": 9132,
	"./collapseGroups.js": 9132,
	"./convertColors": 1200,
	"./convertColors.js": 1200,
	"./convertEllipseToCircle": 1009,
	"./convertEllipseToCircle.js": 1009,
	"./convertPathData": 1219,
	"./convertPathData.js": 1219,
	"./convertShapeToPath": 5221,
	"./convertShapeToPath.js": 5221,
	"./convertStyleToAttrs": 7601,
	"./convertStyleToAttrs.js": 7601,
	"./convertTransform": 3495,
	"./convertTransform.js": 3495,
	"./inlineStyles": 2114,
	"./inlineStyles.js": 2114,
	"./mergePaths": 9162,
	"./mergePaths.js": 9162,
	"./minifyStyles": 7205,
	"./minifyStyles.js": 7205,
	"./moveElemsAttrsToGroup": 1124,
	"./moveElemsAttrsToGroup.js": 1124,
	"./moveGroupAttrsToElems": 2177,
	"./moveGroupAttrsToElems.js": 2177,
	"./prefixIds": 9004,
	"./prefixIds.js": 9004,
	"./removeAttributesBySelector": 8541,
	"./removeAttributesBySelector.js": 8541,
	"./removeAttrs": 4229,
	"./removeAttrs.js": 4229,
	"./removeComments": 4771,
	"./removeComments.js": 4771,
	"./removeDesc": 6229,
	"./removeDesc.js": 6229,
	"./removeDimensions": 4285,
	"./removeDimensions.js": 4285,
	"./removeDoctype": 9116,
	"./removeDoctype.js": 9116,
	"./removeEditorsNSData": 4472,
	"./removeEditorsNSData.js": 4472,
	"./removeElementsByAttr": 7270,
	"./removeElementsByAttr.js": 7270,
	"./removeEmptyAttrs": 3304,
	"./removeEmptyAttrs.js": 3304,
	"./removeEmptyContainers": 5192,
	"./removeEmptyContainers.js": 5192,
	"./removeEmptyText": 6758,
	"./removeEmptyText.js": 6758,
	"./removeHiddenElems": 3514,
	"./removeHiddenElems.js": 3514,
	"./removeMetadata": 750,
	"./removeMetadata.js": 750,
	"./removeNonInheritableGroupAttrs": 60,
	"./removeNonInheritableGroupAttrs.js": 60,
	"./removeOffCanvasPaths": 4217,
	"./removeOffCanvasPaths.js": 4217,
	"./removeRasterImages": 1394,
	"./removeRasterImages.js": 1394,
	"./removeScriptElement": 7574,
	"./removeScriptElement.js": 7574,
	"./removeStyleElement": 9028,
	"./removeStyleElement.js": 9028,
	"./removeTitle": 8977,
	"./removeTitle.js": 8977,
	"./removeUnknownsAndDefaults": 387,
	"./removeUnknownsAndDefaults.js": 387,
	"./removeUnusedNS": 1895,
	"./removeUnusedNS.js": 1895,
	"./removeUselessDefs": 6053,
	"./removeUselessDefs.js": 6053,
	"./removeUselessStrokeAndFill": 7737,
	"./removeUselessStrokeAndFill.js": 7737,
	"./removeViewBox": 2452,
	"./removeViewBox.js": 2452,
	"./removeXMLNS": 5521,
	"./removeXMLNS.js": 5521,
	"./removeXMLProcInst": 305,
	"./removeXMLProcInst.js": 305,
	"./reusePaths": 1279,
	"./reusePaths.js": 1279,
	"./sortAttrs": 604,
	"./sortAttrs.js": 604,
	"./sortDefsChildren": 1409,
	"./sortDefsChildren.js": 1409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9732;